import React from 'react'
import { navigate } from 'gatsby'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import { usePlanSuggestion } from './usePlanSuggestion'
import { PlanExclusions } from './PlanExclusions'

export const PlanDetails = () => {
  const { currentSelectedPlan, pageType } = usePlanSuggestion()
  return (
    <>
      {currentSelectedPlan() && (
        <div className="plan-details">
          <div className="pt-5 pb-3 container">
            <ReactCSSTransitionGroup
              className="animateContainer"
              transitionName="slide"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              <div className="pt-2 pb-2 row" key={currentSelectedPlan().name}>
                <div className="col-md-4 d-flex">
                  <div className="plan-price">
                    <div className="price-circle">
                      <h2 className="amount">
                        <span>
                          {currentSelectedPlan().currentPricing.sellInc / 100}
                        </span>
                        <p className="charge-cycle">p/mth</p>
                      </h2>
                    </div>
                    <p className="text-center">
                      Minimum total cost $
                      {currentSelectedPlan().currentPricing.sellInc / 100}.00
                    </p>
                  </div>
                </div>
                <div className="col-md-4 d-flex">
                  <div className="plan-info">
                    {pageType === 'mobile' ? (
                      <MobilePlanDetails plan={currentSelectedPlan()} />
                    ) : (
                      <NbnPlanDetails plan={currentSelectedPlan()} />
                    )}
                  </div>
                </div>
                <div className="col-md-4 d-flex">
                  <div className="plan-signup">
                    <a
                      className="btn btn-xl btn-orange btn-accord signup-button"
                      href={
                        pageType === 'mobile'
                          ? `/sim-purchase/?pl=${currentSelectedPlan().code}`
                          : `/sign-up/?pl=${currentSelectedPlan().code}`
                      }
                    >
                      Sign up now
                    </a>
                  </div>
                </div>
              </div>
            </ReactCSSTransitionGroup>
          </div>
          <PlanExclusions />
        </div>
      )}
    </>
  )
}

const MobilePlanDetails = ({ plan }) => {
  const dataAllowance = plan.dataCap.split(' ')[0]
  const costPerMB = plan.currentPricing.sellInc / 100 / dataAllowance / 1024

  return (
    <>
      {plan.isDataOnly ? (
        <ul className="list plans">
          <li className="data-allowance">
            {dataAllowance}GB monthly data allowance
          </li>
          <li>Month-to-month</li>
          <li>Cost of 1MB = ${costPerMB.toPrecision(2)}</li>
          <li>Excess data $10/GB</li>
          <li>Support 365 days a year</li>
        </ul>
      ) : (
        <ul className="list plans">
          <li className="data-allowance">
            {dataAllowance}GB monthly data allowance
          </li>
          <li>Month-to-month</li>
          <li>Unlimited calls & text to standard numbers</li>
          {plan.internationalCallAllowance > 0 && (
            <li>
              ${plan.internationalCallAllowance / 100} international call value
              per month
            </li>
          )}
          <li>Excess data $10/GB</li>
          <li>Support 365 days a year</li>
        </ul>
      )}
    </>
  )
}

const NbnPlanDetails = ({ plan }) => {
  const { currentSpeedIndex } = usePlanSuggestion()
  return (
    <>
      {plan.planType === 'Personal' ? (
        <ul className="list plans nbn-plans">
          <li>
            Typical evening speed{' '}
            <strong>
              {(plan.typicalEveningSpeedInKb / 1024).toFixed(1)} Mbps
            </strong>
          </li>
          <NbnPersonalSpeedDetails speed={currentSpeedIndex} />
          <li>Optional VoIP add-on</li>
        </ul>
      ) : (
        <ul className="list plans nbn-plans">
          <li>
            Typical evening speed{' '}
            <strong>
              {(plan.typicalEveningSpeedInKb / 1024).toFixed(1)} Mbps
            </strong>
          </li>
          <NbnBusinessSpeedDetails speed={currentSpeedIndex} />
          <li>Includes VoIP with unlimited local and national calls</li>
          <li>Static IP address</li>
          <li>Enhanced security through web filtering</li>
          <li>Connection alerts</li>
          <li>24/7 support</li>
        </ul>
      )}
    </>
  )
}

const NbnPersonalSpeedDetails = ({ speed }) => (
  <>
    {
      {
        0: (
          <>
            <li>
              NBN speed tier <strong>nbn25/5</strong>
            </li>
            <li>Standard speed for web essentials.</li>
            <li>Surf, email and download music.</li>
            <li>
              Ideal for small to medium households with 3-5 connected devices.
            </li>
          </>
        ),
        1: (
          <>
            <li>
              NBN speed tier <strong>nbn50/20</strong>
            </li>
            <li>
              Standard speeds ideal for streaming music, video and web browsing.
            </li>
            <li>
              Ideal for family homes with 3-5 people using internet at the same
              time.
            </li>
          </>
        ),
        2: (
          <>
            <li>
              NBN speed tier <strong>nbn100/20</strong>
            </li>
            <li>
              Great for internet enthusiasts. Stream like a pro, enjoy more
              media and live gaming.
            </li>
            <li>Ideal for large households with heavy internet usage.</li>
          </>
        ),
        3: (
          <>
            <li>
              NBN speed tier <strong>nbn100/40</strong>
            </li>
            <li>
              Great for internet enthusiasts. Stream like a pro, enjoy more
              media and live gaming.
            </li>
            <li>Ideal for large households with heavy internet usage.</li>
          </>
        ),
      }[speed]
    }
  </>
)

const NbnBusinessSpeedDetails = ({ speed }) => (
  <>
    {
      {
        0: (
          <>
            <li>
              NBN speed tier <strong>nbn25/5</strong>
            </li>
          </>
        ),
        1: (
          <>
            <li>
              NBN speed tier <strong>nbn50/20</strong>{' '}
            </li>
          </>
        ),
        2: (
          <>
            <li>
              NBN speed tier <strong>nbn100/40</strong>
            </li>
          </>
        ),
      }[speed]
    }
  </>
)
